module.exports = __webpack_public_path__ + "img/emoji_26.ef3740f2.png";